import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import Field from "../../../components/Field";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FileDownloadRoundedIcon from "@mui/icons-material/FileDownloadRounded";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function DetailsOfDeceased(props: any) {
  const {
    deceasedDetails,
    commentDetails,
    DeceasedCopy,
    handleDeceasedCommentChange,
    deceasedComment,
  } = props;
  const comments = commentDetails?.filter(
    (comment: any) => comment.section_type === "DETAILS_OF_DECEASED"
  );
  return (
    <Grid container spacing={4} p={4} mt={5}>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field label="First Name" value={deceasedDetails?.first_name} />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field label="Last Name" value={deceasedDetails?.last_name} />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field label="Date if birth" value={deceasedDetails?.date_of_birth} />
      </Grid>

      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field
          label="Title of Initials"
          value={deceasedDetails?.title_and_initials}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field
          label="Passport/ID number"
          value={deceasedDetails?.passport_number}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field
          label="Date of death"
          value={deceasedDetails?.date_time_of_death || "N/A"}
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field
          label="Relationship to claimant"
          value={deceasedDetails?.relationship}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field label="Cause of death" value={deceasedDetails?.cause_of_death} />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field
          label="Identification Number*"
          value={deceasedDetails?.identification_number}
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Field
          label="Identification Type*"
          value={deceasedDetails?.identification_type}
        />
      </Grid>
      {DeceasedCopy?.map((doc: any, index: number) => {
        return (
          <Grid size={{ xs: 12 }}>
            <Box width={270} height={48}>
              <Typography fontWeight={600} textAlign="left" fontSize={18}>
                Deceased ID copy
              </Typography>
              <Box
                sx={{
                  background: "#F5EEE9",
                  color: "#FF0000",
                  borderRadius: 1,
                  px: 1.5,
                  py: 0.5,
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <PictureAsPdfIcon />
                <Box
                  display="flex"
                  justifyContent="center"
                  flexDirection="column"
                >
                  <Typography fontSize={14}>{doc.file_name}</Typography>
                </Box>
                <IconButton
                  onClick={() => window.open(doc.file_url, "_blank")}
                  size="small"
                >
                  <FileDownloadRoundedIcon />
                </IconButton>
              </Box>
            </Box>
          </Grid>
        );
      })}
      {comments?.length > 0 && (
        <Grid size={12} mt={4}>
          {comments.map((comment: any, index: number) => (
            <Accordion
              key={index}
              sx={{
                backgroundColor: "#F7F7F7",
                boxShadow: "none",
                borderRadius: "6px",
                mb: 2,
                border: "1px solid #E0E0E0",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel${index}-content`}
                id={`panel${index}-header`}
                sx={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box>
                  <Typography fontWeight={600} fontSize={14}>
                    {comment.commentedByName}{" "}
                    <Typography
                      component="span"
                      fontWeight={600}
                      color="#EC6E00"
                    >
                      - {comment.role_at_time_of_comment?.toUpperCase()}
                    </Typography>
                  </Typography>
                  <Typography fontSize={12} color="text.secondary">
                    {new Date(comment.created_on).toLocaleTimeString("en-US", {
                      hour: "numeric",
                      minute: "2-digit",
                    })}{" "}
                    |{" "}
                    {new Date(comment.created_on).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  fontSize={15}
                  color="#333"
                  lineHeight={1.6}
                  textAlign="left"
                >
                  {comment.content}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Grid>
      )}
      <Grid size={{ md: 12 }} mt={4}>
        <Typography
          variant="body1"
          fontWeight={600}
          fontSize={18}
          sx={{ display: "block", textAlign: "left" }}
        >
          Comment
        </Typography>
        <TextField
          multiline
          rows={4}
          variant="outlined"
          fullWidth
          onChange={handleDeceasedCommentChange}
          value={deceasedComment}
        />
      </Grid>
    </Grid>
  );
}
